import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { NotasFiscaisReportService } from "src/app/shared/services/notas-fiscais-report.service";
import { notasFiscaisReportActions } from "./notas-fiscais-report.actions";
import { NotifyService } from "src/app/shared/services/notify.service";

@Injectable()

export class NotasFiscaisReportEffects {

    constructor(
        private service: NotasFiscaisReportService,
        private action$: Actions,
        private notify: NotifyService
    ) { }

    loadNotasFiscaisReport$ = createEffect(() =>
        this.action$.pipe(
            ofType(notasFiscaisReportActions.loadNotasFiscaisReport),
            exhaustMap(() =>
                this.service
                    .get()
                    .pipe(
                        map((res) => notasFiscaisReportActions.loadNotasFiscaisReportSuccess({ notas_fiscais_report: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(error.error['hydra:description'])
                        })
                    )
            )
        )
    )

}